import type { AgentSessionSummary } from 'agentic-platform-schema';

/** Sessions created by a run may not have a user-facing title yet. */
export function getAgenticChatSessionTitle(session: AgentSessionSummary) {
  return session.title ?? `Untitled conversation — ${new Date(session.created).toLocaleString()}`;
}
